import { render, staticRenderFns } from "./InquiryQuestionnaireInfo.vue?vue&type=template&id=63777b82&"
import script from "./InquiryQuestionnaireInfo.vue?vue&type=script&lang=ts&"
export * from "./InquiryQuestionnaireInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports